import { areaCodeList } from './LocalizationUtils'

/**
 * Validation of Japanese area code
 */
 const digitsReplace = areaCodeList.map(digits => {
  return digits.number.replace(/_/g, '|')
})

class RegExpAreaCode {
  reg: RegExp
  constructor (replaceCode: any) {
    this.reg = new RegExp('^0' + '(' + replaceCode + ')' + '[0-9-]+$')
  }
}

export const regExpAreaCode = {
  one: new RegExpAreaCode(digitsReplace[0]).reg,
  two: new RegExpAreaCode(digitsReplace[1]).reg,
  three: new RegExpAreaCode(digitsReplace[2]).reg,
  four: new RegExpAreaCode(digitsReplace[3]).reg,
  free: new RegExpAreaCode(digitsReplace[4]).reg,
  incomingBilling: new RegExpAreaCode(digitsReplace[5]).reg,
  mobile: new RegExpAreaCode(digitsReplace[6]).reg
}

/**
 * @summary check if the field is exception or not when checking validation
 * @param exemptedFields
 * @param field
 */
export function isException (exemptedFields: string[], field: string): boolean {
	return exemptedFields.some(exemptedField => exemptedField === field)
}

/**
 * @summary check if the variable is object type or not
 * @param variable
 */
export function isObject (variable: any): boolean {
	return typeof variable === 'object'
}

/**
 * @summary check if the variable is boolean type or not
 * @param variable
 */
export function isBoolean (variable: any): boolean {
	return typeof variable === 'boolean'
}

/**
 * @summary check if the variable is Date type or not
 * @param variable
 */
 export function isDate (variable: any): boolean {
	return variable instanceof Date
}

export function isStringArray (array: any): boolean {
	return isArray(array) && array.length > 0 && array.every((item: any) => typeof item === 'string')
}

export function isArray (object: any): boolean {
	return Object.prototype.toString.call(object) === '[object Array]'
}
